import React from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';

import ReturnButton from './ReturnButton';
import MainBoard from '../MainBoard';
import About from '../about/About';
import Achievements from '../achievements/Achievements';
import Education from '../ed-exp/Education';
import Experience from '../ed-exp/Experience';
import SkillsProjects from '../skills-projects/SkillsProjects';
import Sidebar from '../Sidebar';

const ContentPage = ({ data }) => {
    const location = useLocation();

    return (
        <div className='text-white'>
            {location.pathname !== '/' && (
                <div>
                    <Sidebar />
                    <ReturnButton />
                </div>
            )}
            <div className=' py-4'>
                <Routes>
                    <Route path='/' element={<MainBoard data={data} />} />
                    <Route path='/about' element={<About data={data} />} />
                    <Route
                        path='/experience'
                        element={<Experience data={data} />}
                    />
                    <Route
                        path='/education'
                        element={<Education data={data} />}
                    />
                    <Route
                        path='/skills-projects'
                        element={<SkillsProjects data={data} />}
                    />
                    <Route
                        path='/achievements'
                        element={<Achievements data={data} />}
                    />
                </Routes>
            </div>
        </div>
    );
};

export default ContentPage;
